module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/tecnologia.2ac5d6192a60bfb8e3a61b37030bf8ab.png";